<template>
  <!-- Modal -->
  <div class="modal fade" id="study-modal" tabindex="-1"
       role="dialog"
       aria-labelledby="modal-title"
       aria-hidden="true"
       :style="isShowPopup === true ? {display: 'block'} : {display: 'none'}"
       :class="{ show: isShowPopupInterval, start: state === 2 }"
       @click="closePopup">
    <div @click="$event.stopPropagation()" class="modal-dialog modal-dialog-centered s-modal-dialog" :class="state === 3 ? 's-modal-dialog--sm' : ''" role="document">
      <div class="modal-content s-modal-content" v-bind:class="state === 5 ? 's-modal-content--success' : ''">
        <component v-if="typeof modals[state] !== 'undefined'"
                    :is="modals[state]"
                    :data="data"
                    :type="type"
                    :cat="cat"
                    :is-jb="isJb"
                    @closePopup="closePopup"
                    @cancel="cancel"
                    @confirm="confirm"
                    ref="modal"></component>
      </div>
    </div>
  </div>
</template>

<script>
    import modalSuccessTemplate from './modal/ModalPartialSuccess'
    import modalFailTemplate from './modal/ModalPartialFail'
    import modalHintTemplate from './modal/ModalPartialHint'
    import modalStartTemplate from './modal/ModalPartialStart'
    import modalEtcTemplate from './modal/ModalPartialEtc'
    import modalCodeTemplate from './modal/ModalPartialCode'
    import modalAlertTemplate from './modal/ModalPartialAlert'

    export default {
        name: 'stageModalTemplate',
        components: {
          modalSuccessTemplate,
          modalFailTemplate,
          modalHintTemplate,
          modalStartTemplate,
          modalEtcTemplate,
          modalCodeTemplate,
          modalAlertTemplate
        },
        props: ['type', 'cat', 'isJb'],
        data() {
          return {
            modals: {
              2: 'modal-start-template',
              3: 'modal-hint-template',
              4: 'modal-fail-template',
              5: 'modal-success-template',
              6: 'modal-etc-template',
              7: 'modal-code-template',
              8: 'modal-alert-template'
            },
            state: 1,
            data: {},
            isShowPopup: false,
            isShowPopupInterval: false
          }
        },
        watch: {
        /**
         * [ Function :: isShowPopup ]
         *
         * @DES :: 모달 fade 처리를 위해 먼저 display: block 처리 후 show 클래스를 추가합니다.
         * @IP1 :: isShowPopup {bool}
         * @O.P :: null
         */
        isShowPopup(isShowPopup) {
          setTimeout(() => {
            this.isShowPopupInterval = isShowPopup
          }, 1)
        }
      },
        methods: {
          showPopup() {
            this.isShowPopup = true
          },
          closePopup() {
            if (this.state === 8) {
              window.close();
            } else {
              this.isShowPopup = false
            }
          },
          showStartPopup(data) {
            this.data = data
            this.state = 2
            this.showPopup()
          },
          showHintPopup(data) {
            this.data = data
            this.state = 3
            this.showPopup()
          },
          showFailPopup(data) {
            this.data = data
            this.state = 4
            this.showPopup()
            setTimeout(() => { this.$refs.modal.fail() }, 50)
          },
          showSuccessPopup(data) {
            this.data = data
            this.state = 5
            this.showPopup()
            setTimeout(() => { this.$refs.modal.clear() }, 50)
          },
          showEtcPopup(data) {
            this.data = data
            this.state = 6
            this.showPopup()
          },
          showCodeView(data) {
            data = data.split('\n');

            // Tab 간격처리
            const TAB = "&nbsp;";
            let tabSpace = 0;
            data.forEach((code, i)=>{
              if(code.indexOf('}') !== -1) { tabSpace -= 1; } // 탭내리기
              let inputTab = "";
              for(let i=0; i<tabSpace*4; i++) { inputTab += TAB;}
              data[i] = inputTab + code;
              if(code.indexOf('{') !== -1) { tabSpace += 1; } // 탭올리기
            });

            data.pop();

            this.data = data
            this.state = 7
            this.showPopup()
          },
          showAlertPopup(data) {
            this.data = data
            this.state = 8
            this.showPopup()
          },
          cancel(cb) {
            this.$emit('cancel', cb)
            this.closePopup()
          },
          confirm(cb) {
            this.$emit('confirm', cb)
            this.closePopup()
          }
        },
        mounted() {
          this.$emit('onload')
        }
    }
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/stage/StagePartialModal.vue